// interlinked-tdd: exempt -- presentational only.
//
// Landing section: three portal cards that deep-link the chat into a themed
// preset (/chat?theme=…). Mirrors the three MCP Server Portals so a visitor can
// jump straight into a research domain with that portal's full server set
// enabled — no auth, no signup.
import { Link } from "react-router";
import { CHAT_THEMES, THEME_SERVER_COUNTS } from "@/lib/themes";

export function PortalCards() {
  return (
    <section
      aria-label="Pick a domain"
      className="border-t border-border"
      data-testid="landing-themes"
    >
      <div className="mx-auto max-w-5xl px-6 py-16">
        <div className="mb-8 max-w-2xl">
          <p className="font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
            Three portals · pick a domain
          </p>
          <h2 className="mt-2 text-2xl font-semibold tracking-tight md:text-3xl">
            Or jump straight into a research domain.
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
            Each opens the chat with that portal&apos;s full set of databases
            enabled — the same themed bundles you can wire into your own MCP
            client. No signup.
          </p>
        </div>
        <ul className="grid grid-cols-1 gap-px overflow-hidden rounded-md border border-border bg-border md:grid-cols-3">
          {CHAT_THEMES.map((t) => (
            <li key={t.id} className="bg-background">
              <Link
                to={`/chat?theme=${t.id}`}
                data-testid={`landing-theme-${t.id}`}
                className="group flex h-full w-full flex-col gap-3 p-6 text-left transition-colors hover:bg-accent"
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[10px] uppercase tracking-wider text-emerald-600 dark:text-emerald-400">
                    {THEME_SERVER_COUNTS[t.id]} databases
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground transition-colors group-hover:text-foreground">
                    Open →
                  </span>
                </div>
                <h3 className="text-lg font-semibold tracking-tight">{t.name}</h3>
                <p className="text-sm leading-relaxed text-muted-foreground">
                  {t.blurb}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
